<div class="flex justify-center px-4">
  <div class="container mx-auto">
    <div class="h-auto md:h-[80vh] rounded-2xl overflow-hidden mt-32 flex">
      <!-- Left Image -->
      <div
        class="hidden md:block md:w-1/2 bg-cover bg-center"
        style="
          background-image: url('./login.png');
        "
      ></div>

      <!-- Right Form -->
      <div
        class="flex flex-col justify-center md:w-1/2 px-5 md:py-0 py-5 md:px-16 bg-white"
      >
        <h2
          class="text-4xl font-extrabold mb-8"
          [style.color]="'var(--primary)'"
        >
          Forgot Password
        </h2>
        <form
          (ngSubmit)="onSubmit()"
          [formGroup]="forgotPasswordForm"
          class="space-y-6 max-w-md w-full"
        >
          <input
            type="email"
            placeholder="Enter your email address"
            formControlName="email"
            name="email"
            [class]="
              forgotPasswordForm.get('email')?.touched &&
              forgotPasswordForm.get('email')?.invalid
                ? 'focus:ring-2 focus:ring-red-600 border-red-300'
                : 'focus:ring-2 focus:ring-[var(--primary)] border-gray-300'
            "
            required
            class="w-full px-4 py-3 rounded-xl border focus:outline-none"
          />

          <button
            type="submit"
            [disabled]="forgotPasswordForm.invalid || loading"
            [class]="
              loading
                ? ''
                : 'hover:bg-white hover:text-[var(--primary)] cursor-pointer'
            "
            class="w-full flex items-center justify-center gap-1 py-3 bg-[var(--primary)] text-white rounded-xl font-semibold border border-[var(--primary)] transition"
          >
            @if(loading){
            <svg
              class="animate-spin h-5 w-5 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                class="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                stroke-width="4"
              ></circle>
              <path
                class="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
              ></path>
            </svg>
            Sending... }@else { Send Reset Link }
          </button>
        </form>

        <p class="mt-6 text-gray-700">
          Remembered your password?
          <a
            routerLink="/sign-in"
            class="text-[var(--primary)] font-semibold hover:underline cursor-pointer"
            >Sign In</a
          >
        </p>
      </div>
    </div>
  </div>
</div>
